import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "text-muted" }
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = { class: "text-muted" }

import {computed} from 'vue';
import SideMenuInfo
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuInfo.vue";
import DateHelper from "~/ts/library/Date";
import {__} from "~/ts/library/Translate";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import getCurrentVisitTime from "~/operatorApplication/ts/service/buddyList/getCurrentVisitTime";
import ClientInfoReferer
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/ClientInfoReferer.vue";
import ClientInfoPage
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/ClientInfoPage.vue";


import {ref} from 'vue';

let clientInfoCollapsed = ref(false);

const __default__ = {
    name: "ClientSiteVisits"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {},
    canViewReferer: { type: Boolean, default: true },
    canViewSitePageOfClient: { type: Boolean, default: true }
  },
  setup(__props: any) {

let props = __props;

function secondsFormat(seconds: number) {
    return DateHelper.secondsFormatToClosestFloor(seconds);
}

let currentVisitTime = computed(() => {
    return getCurrentVisitTime(props.userdata);
});


return (_ctx: any,_cache: any) => {
  return (!__props.site.isFree)
    ? (_openBlock(), _createBlock(SideMenuCard, {
        key: 0,
        class: "info",
        collapsed: _unref(clientInfoCollapsed),
        "onUpdate:collapsed": _cache[0] || (_cache[0] = ($event: any) => (_isRef(clientInfoCollapsed) ? (clientInfoCollapsed).value = $event : clientInfoCollapsed = $event))
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(__)('Посещения')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(SideMenuInfo, {
            icon: "sign-in",
            truncate: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(__)('Количество заходов на сайт')), 1),
              _createElementVNode("div", null, _toDisplayString(__props.userdata.visitStatistic.visitCount), 1)
            ]),
            _: 1
          }),
          _createVNode(SideMenuInfo, {
            icon: "eye",
            truncate: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(__)('Посещено страниц')), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(__)('Текущий визит')) + ": " + _toDisplayString(__props.userdata.visitStatistic.lastVisitPageCount), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(__)('Всего')) + ": " + _toDisplayString(__props.userdata.visitStatistic.visitedPageCount), 1)
            ]),
            _: 1
          }),
          _createVNode(SideMenuInfo, {
            icon: "clock",
            truncate: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(__)('Время на сайте')), 1),
              _createElementVNode("div", null, _toDisplayString(__props.userdata.status ? _unref(__)('Текущий визит:') : _unref(__)('Последний визит:')) + " " + _toDisplayString(secondsFormat(_unref(currentVisitTime))), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(__)('Всего')) + ": " + _toDisplayString(secondsFormat(__props.userdata.visitStatistic.timeOnSite)), 1)
            ]),
            _: 1
          }),
          (__props.canViewReferer)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (__props.userdata.referer !== __props.userdata.lastReferer)
                  ? (_openBlock(), _createBlock(SideMenuInfo, {
                      key: 0,
                      icon: "external-link-alt",
                      truncate: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(__)('Первый источник перехода')), 1),
                        _createVNode(ClientInfoReferer, {
                          value: __props.userdata.referer
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(SideMenuInfo, {
                  icon: "external-link-alt",
                  truncate: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(__)('Последний источник перехода')), 1),
                    _createVNode(ClientInfoReferer, {
                      value: __props.userdata.lastReferer
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (__props.canViewSitePageOfClient)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (__props.userdata.firstPage)
                  ? (_openBlock(), _createBlock(SideMenuInfo, {
                      key: 0,
                      icon: "file-alt",
                      truncate: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(__)('Первая страница')), 1),
                        _createVNode(ClientInfoPage, {
                          url: __props.userdata.firstPage.url,
                          title: __props.userdata.firstPage.title
                        }, null, 8, ["url", "title"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.userdata.lastPage)
                  ? (_openBlock(), _createBlock(SideMenuInfo, {
                      key: 1,
                      icon: "file-alt",
                      truncate: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(__)('Последняя страница')), 1),
                        _createVNode(ClientInfoPage, {
                          url: __props.userdata.lastPage.url,
                          title: __props.userdata.lastPage.title
                        }, null, 8, ["url", "title"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["collapsed"]))
    : _createCommentVNode("", true)
}
}

})